import { render, staticRenderFns } from "./PhoneNumberForm.vue?vue&type=template&id=6a3080d9&scoped=true&"
import script from "./PhoneNumberForm.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberForm.vue?vue&type=style&index=0&id=6a3080d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3080d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3080d9')) {
      api.createRecord('6a3080d9', component.options)
    } else {
      api.reload('6a3080d9', component.options)
    }
    module.hot.accept("./PhoneNumberForm.vue?vue&type=template&id=6a3080d9&scoped=true&", function () {
      api.rerender('6a3080d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Referral/PhoneNumberForm.vue"
export default component.exports